// extracted by mini-css-extract-plugin
export default {"inputLabel":"styles_inputLabel__Ih8RN"};